import configService from "@/services/config";

const { theme } = configService;

const loadLogo = (logoName) => {
  for (const ext of ["svg", "png"]) {
    try {
      return require(`@/assets/logos/${logoName}.${ext}`);
    } catch (_) {} // eslint-disable-line no-empty
  }
  return null;
};

const logoUrl = loadLogo(theme);
const logoAltUrl = loadLogo(`${theme}-alt`);

export default {
  data() {
    return {
      logoUrl,
      logoAltUrl,
      theme,
    };
  },
};
